import type { survey } from './types'
import transactionData from '../../data/operationTypeData.json'

export class transactionService {
  async getTransactionTypeList(type: number = 0): Promise<{ data: survey[] }> {

    const transactionTypeList = transactionData.data

    let filteredList = transactionTypeList

    if (type === 0) {
      filteredList = transactionTypeList
    } else if (type === 1) {
      filteredList = transactionTypeList.filter((item) => [2, 4, 6].includes(item.id))
    } else if (type === 2) {
      filteredList = transactionTypeList.filter((item) => [1, 3, 5].includes(item.id))
    }

    return { data: filteredList }
  }

  async getOperationAbonoList(): Promise<{ data: survey[] }> {
    const transactionTypeList = transactionData.data
    return { data: transactionTypeList }
  }
}
